<script>

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        lat: {
            type: String,
            required: true
        },
        lng: {
            type: String,
            required: true
        },
    },

    computed: {
        items() {
            let mapItems = []
            mapItems.push(
            {
                'marker_label': 'Kos Marina',
                'lat': '36.890029871451354',
                'lng': '27.302338637985248'
            })
            mapItems.push(
            {
                'marker_label': this.title,
                'lat': this.lat,
                'lng': this.lng
            })
            return mapItems
        }
    },

    data() {
        return {
           map: '',           
           style: [
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                {
                    "color": "#f4f5f5"
                }
                ]
            },
            {
                "featureType": "poi",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "transit",
                "stylers": [
                {
                    "visibility": "off"
                }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                {
                    "color": "#092348"
                }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                {
                    "color": "#f4f5f5"
                }
                ]
            }
            ]
        }
    },
    
    mounted() {
        this.initMap()
    },

    render() {

    },

    methods: {
       initMap() {
           this.map = new google.maps.Map(document.getElementById("map"), {
                styles: this.style
            })
            var bounds = new google.maps.LatLngBounds()
            _.forEach(this.items, (item) => {
                var icon = {
                    url: '/assets/logos/map-marker-larger.png',
                    anchor: new google.maps.Point(132, 49),
                    size: new google.maps.Size(160, 49),
                    labelOrigin: new google.maps.Point(80, 15)
                }                
                if (_.has(item, 'marker_label')) {
                    if (item.marker_label != null) {
                        var label = {
                            text: String(item.marker_label),
                            className: 'text-center font-bold text-black'
                        }
                    }                    
                }                
                const marker = new google.maps.Marker({                    
                    position: new google.maps.LatLng(item.lat, item.lng),
                    icon: icon,
                    label: label,                      
                    map: this.map,                    
                })
                marker.addListener("click", () => {
                    window.open('https://www.google.com/maps/search/?api=1&query='+item.lat+','+item.lng, '_blank')
                }); 
                bounds.extend(marker.getPosition())                     
            })
            this.map.fitBounds(bounds)
            google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
                if (this.map.getZoom() > 11) {
                    this.map.setZoom(this.map.getZoom() - 1);
                }
            })
       }
    }
}
</script>
